/**
 * lib-components
 *
 * Adapptio library to help creating components.
 *
 * @package lib-components
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { createContext } from "react";

/**
 * Translation Context Value
 */
export interface ITranslationContextValue {
	translate: (
		domain: string,
		term: string,
		vars?: { [K: string]: string | number | boolean },
		fallbackValue?: string
	) => string;
}

/**
 *  Translation context
 */
export const TranslationContext = createContext<ITranslationContextValue>({
	translate: null
});
